var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardFront({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 291,
    viewBox: "0 0 506 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481.401 286.701L26.9007 290.601C13.3007 290.701 2.20069 279.801 2.10069 266.201L0.100689 28.7007C0.000688702 15.1007 10.9007 4.00068 24.5007 3.90068L479.001 0.0006826C492.601 -0.0993174 503.701 10.8007 503.801 24.4007L505.801 261.901C505.901 275.401 495.001 286.601 481.401 286.701Z",
    fill: "#4B9CB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.4007 3.90048C10.8007 4.00048 -0.0993174 15.1005 0.0006826 28.7005L1.50068 206.8C1.50068 206.8 123.901 152.1 231.101 104.1C338.301 56.1005 463.801 0.000488281 463.801 0.000488281L24.4007 3.90048Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.301 119.2H71.9007C65.8007 119.2 60.9007 114.3 60.9007 108.2V64C60.9007 57.9 65.8007 53 71.9007 53H146.301C152.401 53 157.301 57.9 157.301 64V108.2C157.201 114.3 152.301 119.2 146.301 119.2Z",
    fill: "#E5CD65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.401 69.2001C121.401 62.0001 115.501 56.1001 108.301 56.1001C101.101 56.1001 95.2007 62.0001 95.2007 69.2001V103.1C95.2007 110.3 101.101 116.2 108.301 116.2C115.501 116.2 121.401 110.3 121.401 103.1V69.2001Z",
    fill: "#F7E277"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.201 78.3999H127.401V93.9999H157.201V78.3999Z",
    fill: "#F7E277"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.401 69.2001V72.3001H157.201V65.9001C157.201 58.8001 151.501 53.1001 144.401 53.1001H118.501C123.801 56.5001 127.401 62.4001 127.401 69.2001Z",
    fill: "#F7E277"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2007 69.2001C89.2007 62.4001 92.8007 56.5001 98.1007 53.1001H73.7007C66.6007 53.1001 60.9007 58.8001 60.9007 65.9001V72.3001H89.3007V69.2001H89.2007Z",
    fill: "#F7E277"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.401 100V103.1C127.401 109.9 123.801 115.8 118.501 119.2H144.401C151.501 119.2 157.201 113.5 157.201 106.4V100H127.401Z",
    fill: "#F7E277"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2007 103.1V100H60.8007V106.4C60.8007 113.5 66.5007 119.2 73.6007 119.2H98.0007C92.8007 115.8 89.2007 109.9 89.2007 103.1Z",
    fill: "#F7E277"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3007 78.3999H60.9007V93.9999H89.3007V78.3999Z",
    fill: "#F7E277"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M468.402 92.0069C473.964 76.6936 466.059 59.7707 450.746 54.2085C435.433 48.6463 418.51 56.551 412.948 71.8643C407.386 87.1775 415.29 104.1 430.604 109.663C445.917 115.225 462.84 107.32 468.402 92.0069Z",
    fill: "#FBB03B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M410.941 108.938C425.702 102.043 432.079 84.4879 425.184 69.7269C418.289 54.966 400.734 48.5894 385.973 55.4843C371.212 62.3793 364.835 79.9348 371.73 94.6958C378.625 109.457 396.181 115.833 410.941 108.938Z",
    fill: "#C1272D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardFront);
export default __webpack_public_path__ + "static/media/credit-card-front.8cc38de41a64446f0238758378341719.svg";
export { ForwardRef as ReactComponent };